import { render, staticRenderFns } from "./guia-list.vue?vue&type=template&id=6938bc4a&"
import script from "./guia-list.vue?vue&type=script&lang=js&"
export * from "./guia-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports